import React from 'react';
import EmrLogo from '../../assets/images/emerson-logo.png';

function EmersonHeader() {
	return (
		<div className="static md:sticky top-0 z-40 lg:relative ">
			<div className="w-full h-5 bg-black lg:flex hidden justify-center">
				<div className="text-white desktop:lg:w-1280 flex justify-end pr-12">
					<span className="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/about-us">
							About Us
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/investors">
							Investors
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a
							target="_blank"
							href="https://www.emerson.com/en-us/careers/diversity-and-inclusion"
						>
							Diversity
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/careers">
							Careers
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a
							target="_blank"
							href="https://www.emerson.com/en-us/esg/sustainability"
						>
							Sustainability
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/contact-us">
							Contact Us
						</a>
					</span>
					<span className="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/news">
							Newsroom
						</a>
					</span>
				</div>
			</div>
			<div className=" bg-white flex justify-center drop-shadow-lg ">
				<div style={{width:"74rem!important"}} className=" desktop:lg:w-[73.5rem] h-14">
					<a target="_blank" href="https://www.emerson.com/en-us">
						<img src={EmrLogo} alt="emerson_logo" className="w-24"/>
					</a>
				</div>
				<div className=" w-full desktop:lg:w-[73rem] grid grid-cols-2 lg:grid-cols-3 md:grid-cols-4 text-center tracking-wide text-sm mt-16 absolute md:mt-5 lg:grid ">
					<div className=" w-full flex justify-center lg:justify-start md:justify-start border-r-2 md:border-r-0 md:col-span-2 lg:col-span-1">
						<span className="w-24 lg:w-52 md:w-52 lg:ml-40 md:ml-40 cursor-pointer hover:text-navy-blue">
							<a
								target="_blank"
								href="https://www.emerson.com/en-us/automation-solutions"
								style = {{ fontWeight: 900 }}
							>
								AUTOMATION SOLUTIONS
							</a>
						</span>
					</div>
					<div className=" w-full flex justify-center md:col-span-2 lg:col-span-1 lg:justify-start md:justify-start">
						<span className="w-44 lg:w-72 md:w-full cursor-pointer hover:text-navy-blue">
							<a
								target="_blank"
								href="https://www.emerson.com/en-us/commercial-residential-solutions"
								style = {{ fontWeight: 900 }}
							>
								COMMERCIAL & RESIDENTIAL SOLUTIONS
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EmersonHeader;
